import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { Activity, UUID } from "@/core/types";

import { getActivityFeed } from "../queryFunctions/getActivityFeed";
import { timelineKeys } from "../keyFactory";

type UseActivityFeedProps<TData = Activity[]> = {
  patientId: UUID | undefined;
  select?: (data: Activity[]) => TData;
};

type ActivityFeedQueryOptions = UseQueryOptions<
  Activity[],
  unknown,
  Activity[],
  ReturnType<typeof timelineKeys.feed>
>;

function optionFactory(patientId: UUID) {
  return {
    queryFn: () => getActivityFeed(patientId),
    queryKey: timelineKeys.feed(patientId),
  } satisfies ActivityFeedQueryOptions;
}

export function useActivityFeed<TData = Activity[]>({
  patientId,
  select,
}: UseActivityFeedProps<TData>) {
  return useQuery({
    ...optionFactory(patientId!),
    enabled: !!patientId,
    select,
  });
}
